var _title, _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVisualizationSelectionLine = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 48 48",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Icon / Visualization Selection / Line / Default")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon-/-Visualization-Selection-/-Line-/-Default"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Bounding-box",
  x: 0,
  y: 0,
  width: 48,
  height: 48
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon",
  fill: "#81848F"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2 46h46v2H0V0h2z",
  id: "Axes"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.001 25.58 39 25.5a2.5 2.5 0 1 1 .865 1.891l-4.88 2.826q.015.14.015.283a2.5 2.5 0 0 1-4.906.681l-6.235-.85a2.501 2.501 0 0 1-4.293.754l-8.57 4.285q.004.064.004.13a2.5 2.5 0 1 1-.898-1.92l8.927-4.463a2.5 2.5 0 0 1 4.659-.828l6.676.91a2.5 2.5 0 0 1 3.618-.713z",
  id: "Line-1",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.172 9.414a2.5 2.5 0 1 1 1.414 1.414l-5.758 5.758a2.5 2.5 0 0 1-4.52 2.117l-6.435.585a2.5 2.5 0 0 1-4.034 1.08l-8.84 4.08.001.052a2.5 2.5 0 1 1-.839-1.868l8.84-4.08L19 18.5a2.5 2.5 0 0 1 4.692-1.203l6.435-.585a2.5 2.5 0 0 1 3.287-1.54z",
  id: "Line-2",
  fillRule: "nonzero"
}))))));
export default SvgVisualizationSelectionLine;